
import React from "react";
import { Editor } from "@tiptap/react";
import { ImageIcon, Video, FileImage, Library } from "lucide-react";
import MenuButton from "../MenuButton";

interface MediaToolsProps {
  editor: Editor;
  onImageButtonClick: () => void;
  onVideoButtonClick: () => void;
  onGalleryButtonClick: () => void;
  onMediaLibraryButtonClick: () => void;
}

const MediaTools = ({
  editor,
  onImageButtonClick,
  onVideoButtonClick,
  onGalleryButtonClick,
  onMediaLibraryButtonClick
}: MediaToolsProps) => {
  return (
    <>
      <div className="h-8 w-px bg-border mx-1" />
      
      {/* Image Button */}
      <MenuButton 
        onClick={onImageButtonClick} 
        icon={<ImageIcon className="h-4 w-4" />} 
        tooltip="Insert Image"
      />
      
      {/* Video Button */}
      <MenuButton 
        onClick={onVideoButtonClick} 
        icon={<Video className="h-4 w-4" />} 
        tooltip="Embed Video"
      />
      
      {/* Gallery Button */}
      <MenuButton 
        onClick={onGalleryButtonClick} 
        icon={<FileImage className="h-4 w-4" />} 
        tooltip="Insert Gallery"
      />
      
      {/* Media Library Button */}
      <MenuButton 
        onClick={onMediaLibraryButtonClick} 
        icon={<Library className="h-4 w-4" />} 
        tooltip="Media Library"
      />
      
      <div className="h-8 w-px bg-border mx-1" />
    </>
  );
};

export default MediaTools;
